var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterSystemIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.448,
    height: 39.448,
    viewBox: "0 0 39.448 39.448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "water-system",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11854",
    "data-name": "Path 11854",
    d: "M227.544,223.414a2.192,2.192,0,1,0,4.384,0c0-.908-1.1-2.712-2.191-4.168C228.646,220.7,227.544,222.509,227.544,223.414Z",
    transform: "translate(-210.012 -202.353)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11855",
    "data-name": "Path 11855",
    d: "M36.468,16.744a2.985,2.985,0,0,0-2.747,1.825H30.333a10.622,10.622,0,0,0-2.294-5.525l2.4-2.4A2.976,2.976,0,1,0,28.8,9.011l-2.4,2.4A10.621,10.621,0,0,0,20.88,9.116V5.727a2.98,2.98,0,1,0-2.311,0V9.116a10.621,10.621,0,0,0-5.525,2.294l-2.4-2.4a2.976,2.976,0,1,0-1.634,1.634l2.4,2.4a10.621,10.621,0,0,0-2.294,5.525H5.728a2.98,2.98,0,1,0,0,2.312H9.116A10.622,10.622,0,0,0,11.409,26.4l-2.4,2.4a2.976,2.976,0,1,0,1.634,1.634l2.4-2.4a10.621,10.621,0,0,0,5.525,2.294v3.388a2.98,2.98,0,1,0,2.311,0V30.333A10.621,10.621,0,0,0,26.4,28.039l2.4,2.4A2.976,2.976,0,1,0,30.437,28.8l-2.4-2.4a10.621,10.621,0,0,0,2.294-5.525h3.388a2.98,2.98,0,1,0,2.747-4.136ZM19.724,25.565a4.508,4.508,0,0,1-4.5-4.5c0-1.124.612-2.579,1.871-4.447a28.221,28.221,0,0,1,1.754-2.326l.878-1.027.878,1.027a28.207,28.207,0,0,1,1.754,2.326c1.259,1.868,1.871,3.323,1.871,4.447a4.509,4.509,0,0,1-4.5,4.5Z",
    transform: "translate(0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterSystemIcon);
export default __webpack_public_path__ + "static/media/water_system_icon.b0b75fa6cecf8b8128cfe03dac445359.svg";
export { ForwardRef as ReactComponent };